<template>
    <div class="panel is-success">
        <div class="panel-heading is-flex is-justify-content-space-between">
            <p>
                Project attributes for {{ selectedScope }}
            </p>
            <div>
                <b-button
                    icon-right="content-copy"
                    :disabled="canCopyCode"
                    class="mr-3"
                    @click="$emit('click-copy-project')">
                    Copy project to other facilities
                </b-button>
                <b-button
                    v-require-can-edit-code="accessArguments"
                    @click="$emit('click-edit-project')">
                    <b-icon
                        icon="pencil"
                        size="is-small" />
                    <span>Edit project for {{ selectedScope }}</span>
                </b-button>
            </div>
        </div>
        <b-table
            class="headless-table"
            :data="selectedProjectAttributes"
            narrowed
            striped>
            <b-table-column
                v-slot="props"
                field="property">
                <b>{{ props.row.property }}</b>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="value">
                <template v-if="['IsValid'].includes(props.row.property)">
                    <bool-element :value="props.row.value" />
                </template>
                <template v-else>
                    {{ props.row.value }}
                </template>
            </b-table-column>
            <template #empty>
                <div class="has-text-centered">
                    No attributes
                </div>
            </template>
        </b-table>
    </div>
</template>
<script lang="ts">
    import BoolElement from '@/shared/components/BoolElement.vue';
    import {
        codeEditPermissionsForLibrary,
        type CanEditCodeOptions,
        requireCanEditCode
    } from '@/shared/directives/requirePermission';
    import type { PropType } from 'vue';
    import _ from 'lodash';

    export default {
        name: 'ProjectAttributesPanel',
        directives: { requireCanEditCode },
        components: { BoolElement },
        props: {
            selectedProjectAttributes: {
                type: Array,
                required: true
            },
            accessArguments: {
                type: Object as PropType<CanEditCodeOptions>,
                required: true
            },
            selectedScope: {
                type: String,
                required: true
            }
        },
        emits: ['click-edit-project', 'click-copy-project'],
        data() {
            return {
                canCopyCode: false
            };
        },
        async mounted() {
            const permissions = await codeEditPermissionsForLibrary('LCIProject');
            return _.keys(permissions).some(scope => permissions[scope] && scope !== this.selectedScope);
        }

    };
</script>
<style scoped>
.headless-table thead {
    display: none;
}
</style>
